import { surahsCount } from './constants';

export const recitersData = [
     {
          name: 'المنشاوي',
          baseUrl: `https://download.quranicaudio.com/quran/muhammad_siddeeq_al-minshaawee/`,
          img: require('./assets/images/Elminshwey.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'حموده عثمان',
          baseUrl: `https://ia801203.us.archive.org/15/items/001_20231216/`,
          img: require('./assets/images/Hamoda.png'),
          surahList: [1],
     },
     {
          name: 'هيثم الدخين',
          baseUrl: `https://server16.mp3quran.net/h_dukhain/Rewayat-Hafs-A-n-Assem/`,
          img: require('./assets/images/Haitham.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'ياسر الدوسري',
          baseUrl: `https://download.quranicaudio.com/quran/yasser_ad-dussary/`,
          img: require('./assets/images/Yasser_dusary.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'سلمان العتيبي',
          baseUrl: `https://server11.mp3quran.net/salman/`,
          img: require('./assets/images/Salman_Al-Otaibi.jpg'),
          surahList: [1, 2, 36, 46, 56, 58, 59, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114],
     },
     {
          name: 'عبد الباسط',
          baseUrl: `https://download.quranicaudio.com/quran/abdul_basit_murattal/`,
          img: require('./assets/images/Abd_El_Basset.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'محمد ايوب',
          baseUrl: `https://download.quranicaudio.com/quran/muhammad_ayyoob_hq/`,
          img: require('./assets/images/Mohamed_Ayoub.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'الحصري',
          baseUrl: `https://download.quranicaudio.com/quran/mahmood_khaleel_al-husaree_iza3a/`,
          img: require('./assets/images/ELhosary.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'مشاري العفاسي',
          baseUrl: `https://download.quranicaudio.com/quran/mishaari_raashid_al_3afaasee/`,
          img: require('./assets/images/Mishari.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'ماهر المعيقلي',
          baseUrl: `https://download.quranicaudio.com/quran/maher_256/`,
          img: require('./assets/images/Maher.png'),
          surahList: surahsCount,
     },
     {
          name: 'عبدالله علي جابر',
          baseUrl: `https://download.quranicaudio.com/quran/abdullaah_alee_jaabir_studio/`,
          img: require('./assets/images/Abdullah_Ali.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'ناصر القطامي',
          baseUrl: `https://download.quranicaudio.com/quran/nasser_bin_ali_alqatami/`,
          img: require('./assets/images/Naser.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'عبد الرشيد صوفي',
          baseUrl: `https://download.quranicaudio.com/quran/abdurrashid_sufi/`,
          img: require('./assets/images/Abdul_Rashid_Sufi.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'سعود الشريم',
          baseUrl: `https://server7.mp3quran.net/shur/`,
          img: require('./assets/images/Saud_Al-Shuraim.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'عبد الرحمن السديس',
          baseUrl: `https://server11.mp3quran.net/sds/`,
          img: require('./assets/images/Abdullrahman_Alsudais.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'حسن صالح',
          baseUrl: `https://server16.mp3quran.net/h_saleh/Rewayat-Hafs-A-n-Assem/`,
          img: require('./assets/images/Hasan_Saleh.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'فارس عباد',
          baseUrl: `https://server8.mp3quran.net/frs_a/`,
          img: require('./assets/images/Fares_Abbad.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'منصور السالمي',
          baseUrl: `https://server14.mp3quran.net/mansor/`,
          img: require('./assets/images/Mansour_Al-Salmi.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'إدريس أبكر',
          baseUrl: `https://server6.mp3quran.net/abkr/`,
          img: require('./assets/images/Idris_Abkar.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'أحمد النفيس',
          baseUrl: `https://server16.mp3quran.net/nufais/Rewayat-Hafs-A-n-Assem/`,
          img: require('./assets/images/Ahmed_Al-Nafis.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'خالد الجليل',
          baseUrl: `https://server10.mp3quran.net/jleel/`,
          img: require('./assets/images/Khalid_Galilee.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'محمد اللحيدان',
          baseUrl: `https://server8.mp3quran.net/lhdan/`,
          img: require('./assets/images/Mohamed_Ellhidan.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'أحمد عبدالرازق نصر',
          baseUrl: `https://ia903103.us.archive.org/19/items/xxxxxxxxxxxxxxxxxxxxxxxxxxx2_20191118_201911/`,
          img: require('./assets/images/Ahmed_Nasr.jpg'),
          surahList: surahsCount,
     },
     {
          name: 'هزاع البلوشي',
          baseUrl: `https://server11.mp3quran.net/hazza/`,
          img: require('./assets/images/Hazza_Al-Balushi.jpg'),
          surahList: [1, 13, 14, 15, 18, 19, 25, 29, 30, 31, 36, 37, 38, 39, 40, 42, 44, 47, 49, 50, 51, 52, 53, 54, 55, 56, 57, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114],
     },
     {
          name: 'عبدالعزيز سحيم (ورش عن نافع) ',
          baseUrl: `https://server16.mp3quran.net/a_sheim/Rewayat-Warsh-A-n-Nafi/`,
          img: require('./assets/images/Abdulaziz_Suhaim.jpg'),
          surahList: [1, 18, 31, 50, 56, 67, 72, 75, 112],
     },
     {
          name: 'إسلام صبحي',
          baseUrl: `https://ia801200.us.archive.org/26/items/002_20231210_202312/`,
          img: require('./assets/images/Islam_Sobhy.jpg'),
          surahList: [1, 2, 3, 4, 5, 6, 7, 8, 11, 12, 13, 14, 15, 17, 18, 19, 20, 21, 23, 24, 25, 26, 27, 29, 30, 31, 32, 34, 35, 36, 38, 41, 42, 44, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 66, 67, 68, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 106, 107, 108, 109, 110, 111, 114],
     },
     {
          name: 'رعد محمد الكردي',
          baseUrl: `https://server6.mp3quran.net/kurdi/`,
          img: require('./assets/images/Raad_Kurdi.jpg'),
          surahList: [1, 2, 3, 12, 13, 17, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 29, 30, 31, 32, 33, 35, 36, 37, 38, 39, 41, 42, 43, 44, 46, 47, 48, 51, 52, 56, 57, 58, 59, 60, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114],
     },
]
